(function (d) {
	const  questionItem = d.querySelectorAll('.faq__heading');

	for (let i = 0; i < questionItem.length; i++) {
		questionItem[i].addEventListener('click', show);
	}
	function show() {
		const item = this.parentNode;
		const isOpen = item.classList.contains('faq__item-open');
		closeActive()
		item.classList.toggle('faq__item-open',!isOpen);
	}

	function closeActive() {
		for (let i = 0; i < questionItem.length; i++) {
			questionItem[i].parentNode.classList.remove('faq__item-open');
		}
	}
})(document);
